<template>
    <div class="documents-style employee-list-table">
        <b-alert show dismissible fade v-if='successmsg'>{{ successmsg }}</b-alert>
        <div class="row no-gutters py-2 mb-3">
            {{ myData }}

            <div class="col-sm-5 company-form-box-title custom-search">
                <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                        <b-icon icon="search"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input type="search" placeholder="Search for pf advance documents " v-model="search"
                        @input="resetPagination()"></b-form-input>
                </b-input-group>
            </div>
            <div class="col-sm-7 cursor-pointer text-right company-form-box-title">
                <template>
                    <b-button @click="addNew(0)">Add Document</b-button>
                </template>
                <b-button @click="downloadSelected()">Download Selected</b-button>
            </div>
        </div>

        <table class="table">
            <thead>
                <tr class="table-head">
                    <td class="checkbox-col">
                        <input type="checkbox" v-model="checkall" @click="selectAll()" /><label></label>
                    </td>
                    <template v-for="column in columns">
                        <th v-if="column.name != 'created_at'" @click="sortBy(column.name)"
                            :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;">{{ column.label }}</th>
                    </template>
                    <th>File</th>
                    <th class="text-center">Action</th>
                </tr>
            </thead>

            <tbody>
                <tr class="table-row border-bottom mx-2" v-for="doc in paginatedData" :key="doc.id">
                    <td class="checkbox-col">
                        <input type="checkbox" class="checkall_personal" v-if="doc.file_name != ''" v-model="checked_list" :value="'uploaded:' + doc.id" /><label></label>
                    </td>
                    <td>{{ doc.name }}</td>
                    <td v-if="doc.instrument_type == 3">Early Settlement Documents</td> <!-- Start: Rejwan: 08-04-2026 Early loan settlement -->
                    <td v-else>{{ types[doc.type].text }}</td> <!-- Start: Rejwan: 08-04-2026 Early loan settlement -->
                    <td class="text-center">
                        <div class="" v-if="doc.file_name != ''">
                            <b-link @click="downloadFileContent(doc.file_name)"> <!-- Rejwan: pf_unified -->
                                <b-icon icon="download" scale="2"></b-icon>
                            </b-link>
                        </div>
                        <div
                            v-else-if="(doc.flg == 1) && (doc.submit_with_in != null) && (doc.submit_with_in != '0000-00-00')">
                            <span v-if="checkPastDate(doc.submit_with_in) == true" class="text-danger">Requested (Upload
                                by
                                {{ doc.submit_with_in }})</span>
                            <span v-else>Requested (Upload by {{ doc.submit_with_in }})</span>
                        </div>
                        <div v-else>No file uploaded</div>
                    </td>

                    <td class=""> <!-- Mustafijur: 16-07-2026: removed float-right -->
                        <div class="position-relative float-right" v-if="doc.type > 2"> <!-- Mustafijur: 16-07-2026: added float-right -->
                            <b-button-toolbar>
                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                    style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false"><b-icon style="color: #4E3E3F;"
                                        icon="three-dots-vertical"></b-icon></a>
                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                    <b-button-group>
                                        <b-button variant="outline-secondary" @click="editDocument(doc.id)">
                                            <b-icon icon="pencil"></b-icon> Edit
                                        </b-button>
                                        <b-button variant="outline-secondary" @click="deleteDocument(doc.id, doc.instrument_type)">
                                            <b-icon icon="trash"></b-icon> Delete
                                        </b-button>
                                    </b-button-group>
                                </div>
                            </b-button-toolbar>
                        </div>
                        <div class="position-relative" v-else>
                            <b-button-toolbar>
                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                    style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false"><b-icon
                                        icon="three-dots-vertical"></b-icon></a>
                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                    <b-button-group>
                                        <b-button variant="outline-secondary"
                                            @click="editFixedDocument(doc.type, doc.id)">
                                            <b-icon icon="pencil"></b-icon> Upload
                                        </b-button>
                                    </b-button-group>
                                </div>
                            </b-button-toolbar>
                        </div>
                    </td>
                </tr>
                
            </tbody>
        </table>

        <div v-if="paginatedData.length > 0">
            <div :colspan=6>
                <div class="row p-2 float-right">
                    <b-pagination-nav v-model="pagination.currentPage" :number-of-pages="pagination.pages"
                        base-url="#" prev-text="Previous" next-text="Next" first-number last-number></b-pagination-nav>
                </div>
            </div>
        </div>
        <div v-if="paginatedData.length == 0">
            <div :colspan=6>
                <div class="mt-4 d-flex justify-content-center"> {{ blankmsg }} </div>
            </div>
        </div>


        <b-modal id="bv-modal-personal-documents" size="lg" hide-footer no-close-on-backdrop
            :title="modalTitle" v-if="flg > 0">
            <ul>
                <li clase="text-uppercase" v-for='data in errormsg'>{{ data[0] }}</li>
            </ul>
            <b-overlay :show="showoverlay" rounded="sm" class="trz_overlay_custom">
                <b-form @submit.stop.prevent="onSubmit">
                    <input type="hidden" v-model="fdata.id" name="id">

                    <b-form-group id="name-group" label="Name" class="required-field" label-for="name">
                        <b-form-input id="name" name="name" :disabled="disable_me" v-model="fdata.name"
                            v-validate="{ required: true, min: 3 }" :state="validateState('name')"
                            aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                        <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name')
                            }}</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group id="type-group" class="" label="Type" label-for="type">
                        <template v-if="this.type_text.length > 0">
                            <b-form-input :value="type_text" :disabled="disable_me"></b-form-input>
                        </template>

                        <template v-else>
                            <b-form-select id="type" name="type" v-model="fdata.type" v-validate="{ required: true }"
                                :options="types_options" @change="checkType()" :state="validateState('type')"
                                aria-describedby="type-feedback" data-vv-as="Type" disabled></b-form-select>
                            <b-form-invalid-feedback id="type-feedback">{{ veeErrors.first('type')
                                }}</b-form-invalid-feedback>
                        </template>
                    </b-form-group>

                    <b-form-group id="upload_doc_file-group" label="File" label-for="upload_doc_file"
                        v-if="request == 0">
                        <b-form-file id="upload_doc_file" ref="upload_doc_file" v-model="upload_doc_file"
                            accept=".jpg, .png, .gif, .pdf , .doc , .docx" @change="fieldChange"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."></b-form-file>
                    </b-form-group>

                    <template v-if="this.flg == 1">
                        <b-form-group id="submit_with_in-group" label="Deadline [YYYY-MM-DD] - Optional"
                            label-for="submit_with_in" class="mt-4" v-if="this.fdata.flg == 1">
                            <b-input-group class="mb-3">
                                <b-form-input id="submit_with_in" name="submit_with_in" v-model="fdata.submit_with_in"
                                    type="text" placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>
                                <b-input-group-append>
                                    <b-form-datepicker id="submit_with_in" button-only right locale="en-US"
                                        v-model="fdata.submit_with_in" :min="date_min"></b-form-datepicker>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </template>

                    <div class=" full-width text-center mt-3">
                        <b-button type="submit" variant="primary">Submit</b-button>
                        <b-button class="ml-2" @click="resetForm()">Reset</b-button>
                    </div>
                </b-form>
            </b-overlay>
        </b-modal>


    </div>
</template>


<script>

export default {

    mounted() {
    },
    // props: ['pageurl', 'flg', 'loan_id'], // Start: Rejwan: 08-04-2026 Early loan settlement
    props: ['pageurl', 'flg', 'loan_id', 'type'], // Start: Rejwan: 08-04-2026 Early loan settlement
    data() {

        let sortOrders = {};
        let columns = [
            { label: 'Name', name: 'name' },
            { label: 'Type', name: 'type' },
            { label: '', name: 'created_at' },

        ];
        columns.forEach((column) => { sortOrders[column.name] = -1; });

        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const minDate = new Date(today);

        return {

            date_min: minDate,
            checked_list: [],
            checkall: false,

            existing_types: [],
            documents: [],
            successmsg: null,
            errormsg: [],
            showoverlay: false,
            fdata: { id: null, name: null, type: 5, submit_with_in: '', flg: 0 },
            upload_doc_file: null,
            disable_me: false,
            types: [
                { value: null, text: "Select..." },
                { value: "1", text: "NID" },
                { value: "2", text: "Passport" },
                { value: "3", text: "Educational Certificates" },
                { value: "4", text: "Previous Employment Documents" },
                { value: "5", text: "Advance Documents" },
            ],

            type_text: '',
            request: 0,

            types_options: [],

            blankmsg: 'Fetching data..',
            search: '',

            columns: columns,
            sortKey: 'name',
            sortOrders: sortOrders,
            length: 20,
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
            up_file: [],
            modalTitle: 'PF Advance Documents',

        }
    },
    methods: {
        fieldChange(e) {




            var handle_return = this.checkFileType(e, 'upload_doc_file', ['.jpg', '.png', '.gif', '.pdf', '.doc', '.docx']);
            if (handle_return == false) {
                return 0;
            }

            console.log(this.upload_doc_file);
            let selectedFiles = e.target.files;
            this.up_file = [];
            if (!selectedFiles.length) {
                return false;
            }
            this.upload_doc_file = null;
            var name = '';
            var extensions = ["jpg", "png", "gif", "pdf", "doc", "docx"];
            for (let i = 0; i < selectedFiles.length; i++) {

                name = selectedFiles[i].name;
                var fileExt = name.split('.').pop();
                fileExt = fileExt.toLowerCase();
                if (extensions.indexOf(fileExt) < 0) {

                    this.upload_doc_file = null;
                    console.log(this.upload_doc_file);
                    this.up_file = [];
                    this.$bvToast.toast('Uploaded file is not supported', {
                        title: `Error`,
                        variant: 'danger',
                        solid: true
                    });


                    return;
                }


            }
        },
        downloadSelected: function () {
            if (this.checked_list.length == 0) {
                this.$bvToast.toast('No document selected.', {
                    title: `Warning`,
                    variant: 'warning',
                    solid: true
                });

                return false;
            }

            if (!this.checkNet()) return false;
            let currentObj = this;

            let url = '';
            url = this.$api_url + '/documents/zip/download';

            this.$bvToast.toast('It might take a while', {
                title: `Info`,
                variant: 'info',
                solid: true
            });

            let formData = new FormData();

            formData.append('checked_list', this.checked_list);
            formData.append('type', 'personal');
            formData.append('instrument_id', this.loan_id);
            formData.append('instrument_type', 1);

            axios.post(url, formData)
            .then(function (response) {
                this.downloadFileContent(response.data);

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        selectAll: function () {
            this.checkall = !this.checkall;
            var y = document.getElementsByClassName("checkall_personal");
            var i;
            for (i = 0; i < y.length; i++) {
                if (y[i].checked != this.checkall)
                    y[i].click();
            }
        },
        formatNames(files) {
            return files.length === 1 ? files[0].name : `${files.length} files selected`;
        },
        checkType: function () {
            if ((this.fdata.type < 3) && (this.fdata.id == null)) {
                this.fdata.name = this.types[this.fdata.type].text;
                this.disable_me = true;
            }
            else {
                if (this.fdata.id == null) {
                    this.disable_me = false;
                    this.fdata.name = '';
                }
            }
        },
        getDocumentList: function () {
            if (!this.checkNet()) return false;

            let currentObj = this;
            axios.get(this.$api_url + '/personal-document', {
                params: {
                // Start: Rejwan: 16-02-2025
                    // is_loan: 1,
                    // loan_id: this.loan_id,
                    'instrument_type': this.type == 'loan_early_settlement' ? 3 : 1, // Start: Rejwan: 08-04-2026 Early loan settlement
                    'instrument_id': this.loan_id
		// End: Rejwan: 16-02-2025
                }
            }).then(function (response) {
                
                this.documents = response.data.list;

                this.types_options = response.data.types_options;

                if (this.documents.length == 0)
                    this.blankmsg = "No doucments found";

                else {

                    this.sortOrders['created_at'] = 1;
                    this.sortBy('created_at');
                }



            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        editFixedDocument: function (x, y) {
            this.editDocument(y)
            this.fdata.type = x;
            //this.fdata.id = null;

            if (x == 1) this.fdata.name = "NID";
            else this.fdata.name = "Passport";

            this.type_text = this.fdata.name;
            this.disable_me = true;
        },
        editDocument: function (x) {
            if (!this.checkNet()) return false;
            let currentObj = this;


            axios.get(this.$api_url + '/personal-document/details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.fdata = response.data;

                if (this.fdata.type < 3) this.disable_me = true;
                else this.disable_me = false;

                this.$validator.reset();

                this.request = 0;

                this.modalTitle = 'Edit PF Advance Documents'
                this.$bvModal.show('bv-modal-personal-documents');

            }.bind(this)).catch(function (error) { 
                currentObj.hr_showoverlay = false; currentObj.serverError(error); 
                // Start: Rejwan: 23-06-2026
                currentObj.$bvToast.toast('Please upload a valid file', {
                    title: `Error`,
                    variant: 'danger',
                    solid: true
                });
                // End: Rejwan: 23-06-2026
            });

        },
        deleteDocument(id, instrument_type) {
            if (!this.checkNet()) return false;
            let currentObj = this;

            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this work location.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {

                        this.showoverlay = true;
                        let formData = new FormData();
                        formData.append('id', id);
                        formData.append('instrument_type', instrument_type);
                        formData.append('instrument_id', this.loan_id);

                        axios.post(this.$api_url + '/personal-document/delete', formData).then(function (response) {

                            if (response.data.status == true) {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                                this.getDocumentList();

                            }
                            else {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Warning`,
                                    variant: 'warning',
                                    solid: true
                                });
                            }

                            this.resetPagination();
                            this.showoverlay = false;

                        }.bind(this))
                            .catch(function (error) {
                                currentObj.showoverlay = false;
                                currentObj.serverError(error);
                            });
                    }
                })
                ;
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.fdata = { id: null, name: '', type: 5, submit_with_in: '' };
            this.upload_doc_file = null;
            this.disable_me = false;
            this.type_text = '';

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        addNew(x) {
            this.resetForm();

            if (x == 1) {
                this.fdata.flg = 1;
                this.request = 1;
            }
            else {
                this.fdata.flg = 0;
                this.request = 0;
            }

            this.modalTitle = 'Add PF Advance Documents';
            this.$bvModal.show('bv-modal-personal-documents');
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.warningmsg = null;
            this.successmsg = null;


            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.showoverlay = true;

                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                


                if (this.fdata.submit_with_in != 'undefined' && this.fdata.submit_with_in != null && this.fdata.submit_with_in != '0000-00-00') {

                    if (this.fdata.submit_with_in != '') {
                        let submit_with_in = this.fdata.submit_with_in.split('-');
                        const submit_with_in_date = new Date(submit_with_in[0], submit_with_in[1] - 1, submit_with_in[2]);
                        const submit_with_in_date_final = new Date(submit_with_in_date);



                        const now2 = new Date()
                        const today2 = new Date(now2.getFullYear(), now2.getMonth(), now2.getDate())
                        const currentDate = new Date(today2);

                        if (currentDate.getTime() > submit_with_in_date_final.getTime()) {
                            this.showoverlay = false;
                            this.$bvToast.toast('Deadline cannot be an older date !', {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            });

                            return;

                        }

                    }

                }

                let formData = new FormData();

                if (this.upload_doc_file == null) {
                    this.showoverlay = false;
                    this.$bvToast.toast('Please upload a file', {
                        title: `Error`,
                        variant: 'danger',
                        solid: true
                    });

                    return;
                }
                if (this.upload_doc_file)
                    formData.append('upload_file', this.upload_doc_file);

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                formData.append('updated_by', this.flg);
                formData.append('loan_id', this.loan_id);
                
               // Start: Rejwan: 08-04-2026 Early loan settlement
                if(this.type == 'loan_early_settlement') {
                    formData.append('instrument_type', 3);
                } else {
                    formData.append('instrument_type', 1);
                }
                // End: Rejwan: 08-04-2026 Early loan settlement
                formData.append('instrument_id', this.loan_id);
                // End: Rejwan: 16-02-2025  

                axios.post(this.$api_url + '/personal-document/details', formData, config)
                    .then(function (response) {
                        //console.log(response.data);
                                           
                        this.getDocumentList();

                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.showoverlay = false;
                        this.resetForm();

                        this.$bvModal.hide('bv-modal-personal-documents');

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.showoverlay = false;

                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                        // Start: Rejwan: 23-06-2026
                        currentObj.$bvToast.toast('Please upload a valid file', {
                            title: `Error`,
                            variant: 'danger',
                            solid: true
                        });
                        // End: Rejwan: 23-06-2026
                    });
            });
        },

    },
    created: function () {
        this.getDocumentList();
        Fire.$on('reloaddocuments', () => { this.getDocumentList() })
    },
    computed:
    {
        myData() {
            if (this.upload_doc_file != '' && this.upload_doc_file != null) {
                console.log(this.upload_doc_file);

                var name = '';
                var extensions = ["jpg", "png", "gif", "pdf", "doc", "docx"];


                name = this.upload_doc_file.name;
                var fileExt = name.split('.').pop();
                fileExt = fileExt.toLowerCase();
                if (extensions.indexOf(fileExt) < 0) {

                    this.upload_doc_file = null;


                }
            }

        },
        filteredData() {
            let filtered_list = this.documents;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });

                if (filtered_list.length == 0)
                    this.blankmsg = "No doucments found";
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;
            if (sortKey) {
                filtered_list = filtered_list.slice().sort((a, b) => {
                    let index = this.getIndex(this.columns, 'name', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    if (this.columns[index].type && this.columns[index].type === 'date') {
                        return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                    }
                    else if (this.columns[index].type && this.columns[index].type === 'number') {
                        return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                    }
                    else {
                        return (a === b ? 0 : a > b ? 1 : -1) * order;
                    }
                }
                );
            }

            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    }
}
</script>
